import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../config";
import { NavLink } from "react-router-dom";
import AuthFormContainer from "../../components/AuthFormContainer/AuthFormContainer";
import AuthFormFooter from "../../components/AuthFormFooter/AuthFormFooter";
import AuthFormLabel from "../../components/AuthFormLabel/AuthFormLabel";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import Upload from "../../components/Upload/Upload";

const Signup = (props) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [nationality, setNationality] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("Other");
  const [profession, setProfession] = useState("");
  const [iah, setIah] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [image, setImage] = useState("default.jpeg");
  const [loading, setLoading] = useState(false);

  const createUser = () => {
    setLoading(true);
    const data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("nationality", nationality);
    data.append("dateOfBirth", dob);
    data.append("gender", gender);
    data.append("profession", profession);
    data.append("interestsAndHobbies", iah);
    data.append("password", password);
    data.append("confirmPassword", confirmPassword);
    data.append("image", image);

    axios
      .post(`${API}/signup`, data)
      .then((response) => {
        setLoading(false);
        swal("Sign up success!", `${response.data.message}`, "success", {
          button: "Okay",
        });
      })
      .catch((err) => {
        setLoading(false);
        swal("Error!", `${err.response.data.message}`, "error", {
          button: "Okay",
        });
      });
  };

  return (
    <AuthFormContainer
      form={
        <>
          <Input
            type={"text"}
            p={"Please enter your full name"}
            setFn={setName}
          />
          <Input
            type={"email"}
            p={"Please enter your email"}
            setFn={setEmail}
          />
          <Input
            type={"text"}
            p={"Please enter your nationality"}
            setFn={setNationality}
          />
          <AuthFormLabel label={"Please enter your date of birth"} />
          <Input
            type={"date"}
            p={"Please enter your date of birth"}
            setFn={setDob}
          />
          <AuthFormLabel label={"Please select your gender"} />
          <Select opt={["Male", "Female", "Other"]} setFn={setGender} />
          <Input
            type={"text"}
            p={"Please enter your profession"}
            setFn={setProfession}
          />
          <Input
            type={"text"}
            p={"Please enter your interests and hobbies"}
            setFn={setIah}
          />
          <AuthFormLabel label={"Please select your profile picture"} />
          <Upload
            i={{
              id: "profile_image",
              setFn: setImage,
            }}
          />
          <Input
            type={"password"}
            p={"Please enter your password"}
            setFn={setPassword}
          />
          <Input
            type={"password"}
            p={"Please re-enter your password"}
            setFn={setConfirmPassword}
          />
          <Button text={"Sign Up"} loader={loading} clickFn={createUser} />
          <AuthFormFooter
            l1={
              <>
                Forgot password?{" "}
                <NavLink to={"/forget"}>Click here to reset</NavLink>
              </>
            }
            l2={
              <>
                Already have an account?{" "}
                <NavLink to={"/login"}>Click here to login</NavLink>
              </>
            }
          />
        </>
      }
    />
  );
};

export default Signup;
